<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 系统配置
                </el-breadcrumb-item>
                <el-breadcrumb-item>企微配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >  
 
                <span class="label-span">
                    <label class="label">企业名称</label> 
                    <el-input v-model.trim="query.corpName" placeholder="企业名称" class="handle-input mr10"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">群聊名称</label> 
                    <el-input v-model.trim="query.chatName" placeholder="群聊名称" class="handle-input mr10"></el-input> 
                </span> 
                <el-button type="success" icon="el-icon-search"    @click="handleSearch">搜索</el-button>
                <el-button type="warning" icon="el-icon-refresh"    @click="refreshSearch">重置</el-button> 
                <el-button type="primary" icon="el-icon-lx-roundadd" class="mr10"   @click="addBind" >发送消息</el-button> 
                
            </el-card>
            <el-card shadow="hover"  class="containCard" > 
            <el-table :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header"   >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="id" width="50" align="left" label="ID"></el-table-column>
                <el-table-column prop="chatName" min-width="120" align="left" label="群聊名称"> </el-table-column>  
                <!--<el-table-column prop="corpName" min-width="190" align="left" label="企业名称"></el-table-column> -->  
                <el-table-column prop="level" width="80" align="center" label="消息级别">
                    <template slot-scope="scope">
                         <el-tag :type="scope.row.level==1?'primary':scope.row.level==2?'warning':scope.row.level==3?'danger':'info'" >{{scope.row.level==1?"通知":scope.row.level==2?"预警":scope.row.level==3?"异常":""}}</el-tag>
                    </template>  
                </el-table-column>  
                 <el-table-column prop="msg" min-width="230" align="left" label="消息内容">
                    <template slot-scope="scope">
                        <el-popover placement="bottom" title="详细信息"  width="600" trigger="hover" :content="scope.row.msg">
                            <span slot="reference" >{{scope.row.msg.length>38?scope.row.msg.substr(0,35)+'...':scope.row.msg}}</span>
                        </el-popover> 
                    </template>  
                </el-table-column>  
                 <el-table-column prop="sure" min-width="80" align="center" label="发送状态">
                    <template slot-scope="scope"> 
                        <el-tag :type="scope.row.sure==1?'success':'danger'">
                            {{scope.row.sure==1?'成功':'失败'}}
                        </el-tag> 
                    </template>
                </el-table-column>
                <el-table-column prop="sure" min-width="80" align="left" label="状态说明">
                    <template slot-scope="scope">
                         <p v-if="scope.row.fb1!=null && scope.row.fb1!=''">
                            <el-popover placement="bottom" title="详细信息"  width="600" trigger="hover" :content="scope.row.fb1">
                                <span style="background:none;color:#999;border:none;" slot="reference" >{{scope.row.fb1.length>18?scope.row.fb1.substr(0,15)+'...':scope.row.fb1}}</span>
                            </el-popover> 
                            </p>
                    </template>
                </el-table-column>  
                <el-table-column prop="createTime" width="160" align="center"  label="发送时间"> </el-table-column>  
                <el-table-column label="操作" width="150" align="center" fixed="right">
                    <template slot-scope="scope">  
                         <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  prev, pager, next" 
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 新建代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="发送消息" :modal-append-to-body='false' :visible.sync="addPlusVisible"  width="520px">
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item label="选择群聊" >
                    <el-select v-model="form1.gid"  placeholder="所属企业" filterable clearable style="width:100%;" class="handle-input mr10"> 
                            <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                        </el-select>   
                </el-form-item>   
                <el-form-item label="消息级别" > 
                    <el-radio-group  v-model.trim="form1.level" >
                        <el-radio-button label="1">通知</el-radio-button> 
                        <el-radio-button label="2">预警</el-radio-button>
                        <el-radio-button label="3">异常</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>  
                <el-form-item label="消息内容" >
                    <el-input  v-model.trim="form1.msg"  placeholder="必填"></el-input>   
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">发 送</el-button>
            </span>
        </el-dialog>
  

     
        <!-- 编辑代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑群聊" :modal-append-to-body='false' :visible.sync="editPlusVisible"  width="520px">
            <el-form ref="form" :model="form3" label-width="90px">
                <el-form-item label="选择群聊" >
                    <el-select v-model="form3.cid"  placeholder="所属企业" filterable clearable style="width:100%;" class="handle-input mr10"> 
                            <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                        </el-select>   
                </el-form-item>   
                <el-form-item label="消息级别" > 
                    <el-radio-group  v-model.trim="form3.level" >
                        <el-radio-button label="1">通知</el-radio-button> 
                        <el-radio-button label="2">预警</el-radio-button>
                        <el-radio-button label="3">异常</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>  
                <el-form-item label="消息内容" >
                    <el-input  v-model.trim="form3.msg"  placeholder="必填"></el-input>   
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="editPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog> 
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus} from '../../api/wxWorkMsg';  
import {fetchSelect } from '../../api/wxWorkGroup';   
export default {

    data() {
        return {  
            Timeout:'',
            mid:'', 
            secret:'',
            stationId:'', 
            loginName:'',
            activeNames:1,
            userlist:[],
            select:{ option:'',  },
            select2:{ option:'',  }, 
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: { 
                level:'1', 
            },
            form2: {   },
            form3: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
        this.getSelect(); 
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'corpName', '');  
            this.$set(this.query, 'chatName');   
        }, 
     
        //触发刷新按钮
        refresh(){
            history.go(0);
            
        },

        //获取下拉框数据
        getSelect(){   
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        }, 
        getSelect2(cid){   
            this.select2.cid = cid;
            fetchSelect2(this.select2).then(res => {   
                if(res.code=='200'){ 
                    this.select2.option = res.data; 
                }
            });
        }, 

        //查询
        getData(){  
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        }, 

        // 新增渠道
        addBind() {
            this.addPlusVisible = true; 
        },
        //保存新增
        saveForm() {   
            if( !this.form1.gid ){
                this.$message.error("请选择群聊");
                return;
            } 
            if( !this.form1.level ){
                this.$message.error("请选择消息级别");
                return;
            }  
            if( !this.form1.msg ){
                this.$message.error("请填写消息内容");
                return;
            }    
            saveForm(this.form1).then(res => {
                if(res.code=='200'){
                    this.addVisible = false;
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },
 
        // 编辑操作
        handleEdit(index, row) {  
            this.editPlusVisible = true;
            this.form3 = row;   
        },

         
        // 保存更改
        saveEdit() {   
             if( !this.form3.gid ){
                this.$message.error("请选择群聊");
                return;
            } 
            if( !this.form3.level ){
                this.$message.error("请选择消息级别");
                return;
            }  
            if( !this.form3.msg ){
                this.$message.error("请填写消息内容");
                return;
            }    
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.editPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            let data = {};
            data.id = row.id;
            data.status = row.status;
            changeStatus(data).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message);
                    if(row.status=='1'){
                        row.status = '0';
                    }else{
                        row.status = '1';
                    } 
                } 
            }); 
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('去顶要删除该商户吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
